module.exports = __webpack_public_path__ + "img/beach-ocean-sea-seafoam.1b1f5943.jpg";